enum EnrollmentType {
    DIRECT = "DIRECT",
    INVITATION_NO_NOTIFICATION = "INVITATION_NO_NOTIFICATION"
}

export default EnrollmentType;